<div class="transactions">
  <div>
    <div class="search-container">
      <div class="datepicker-container" [class.unclickable]="initialDateIsSet">
        <mat-form-field (click)="picker.open()">
          <input
            matInput
            readonly
            placeholder="Fecha de inicio"
            class="general-hide"
            [matDatepicker]="picker"
            [max]="maxDateInitial"
            [(ngModel)]="beginDate"
            (dateInput)="
              changeBeginDate($event.target.value);
              pickerEnd.open();
              showInterval('end');
              applyToday()
            "
          />
          <div class="parsed-date">{{ label.initial }}</div>
          <img class="calendar-arrow" src="/images/icons/atm-black-arrow.svg" />
          <mat-datepicker #picker> </mat-datepicker>
        </mat-form-field>

        <mat-form-field (click)="pickerEnd.open(); applyToday()">
          <input
            matInput
            readonly
            placeholder="Fecha de fin"
            class="general-hide"
            [matDatepicker]="pickerEnd"
            [max]="maxDate"
            [min]="beginDate"
            [(ngModel)]="endDate"
            (dateInput)="changeEndDate($event.target.value)"
          />
          <div class="parsed-date">{{ label.final }}</div>
          <img class="calendar-arrow" src="/images/icons/atm-black-arrow.svg" />
          <mat-datepicker #pickerEnd></mat-datepicker>
        </mat-form-field>
      </div>

      <ul class="belt-pills" [class.unclickable]="initialDateIsSet">
        <li
          class="button-pill-primary"
          [class.button-pill-primary--active]="isByOperation"
          (click)="searchData()"
        >
          <span>Operación</span>
        </li>
        <li
          class="button-pill-primary"
          [class.button-pill-primary--active]="!isByOperation"
          (click)="searchData(false)"
        >
          <span>Liquidación</span>
        </li>
      </ul>
    </div>
    <div class="download-control" [class.unclickable]="initialDateIsSet">
      <a
        *ngIf="noRows > 0"
        class="download-excel"
        (click)="parseData('.transactions-body')"
      >
        Descargar Excel
      </a>
    </div>
  </div>

  <div class="table-grid-nvo">
    <ul class="header-grid">
      <li
        class="li-text-format"
        *ngIf="isByOperation"
        (click)="sortingBy('operationDate')"
      >
        <div class="wrapper">
          <label>Fecha</label>
          <div class="sort-icon"></div>
        </div>
      </li>
      <li
        class="li-text-format"
        *ngIf="!isByOperation"
        (click)="sortingBy('settlementDate')"
      >
        <div class="wrapper">
          <label>Fecha</label>
          <div class="sort-icon"></div>
        </div>
      </li>
      <li class="li-text-format">Hora</li>
      <li class="li-text-format long-text issue" (click)="sortingBy('issueId')">
        <div class="wrapper">
          <label>Emisora/Fondo</label>
          <div class="sort-icon"></div>
        </div>
      </li>
      <li class="li-text-format description" (click)="sortingBy('description')">
        <div class="wrapper">
          <label>Tipo de orden</label>
          <div class="sort-icon"></div>
        </div>
      </li>
      <li class="li-number-format">Títulos</li>
      <li class="li-number-format">Precio</li>
      <li class="li-number-format">Tasa</li>
      <li class="li-number-format plazo" (click)="sortingBy('term')">
        <div class="wrapper">
          <label>Plazo</label>
          <div class="sort-icon"></div>
        </div>
      </li>
      <li class="li-number-format">Intereses</li>
      <li class="li-number-format">Impuestos</li>
      <li class="li-number-format">Comisión</li>
      <li class="li-number-format" (click)="sortingBy('amount')">
        <div class="wrapper">
          <label>Importe</label>
          <div class="sort-icon"></div>
        </div>
      </li>
    </ul>
    <div class="body-grid" *ngIf="!showSkeleton">
      <ng-container *ngFor="let t of transactions">
        <ul
          *ngFor="
            let tr of t.transactions;
            let index = index;
            let odd = odd;
            let even = even
          "
          class="row-grid"
        >
          <li class="li-text-format">
            <span *ngIf="isByOperation">
              {{ tr.operationDate }}
            </span>
            <span *ngIf="!isByOperation">
              {{ tr.settlementDate }}
            </span>
          </li>
          <li class="li-text-format">
            <span *ngIf="isByOperation">
              {{ tr.timeOp }}
            </span>
            <span *ngIf="!isByOperation">
              {{ tr.timeSt }}
            </span>
          </li>
          <li class="li-issue-format long-text">
            <span>
              {{ tr.issueId }}
            </span>
          </li>
          <li
            class="li-text-format ellipsis"
            (mouseenter)="showTooltip($event)"
            (mouseleave)="hideTooltip($event)"
          >
            {{ tr.description }}

            <hb-tooltip-component
              class="fixed transactions__tooltip"
              [style.top]="constTop + 'px'"
              [style.left]="constLeft + 'px'"
              [text]="tr.description"
              [relativePosition]="'left'"
            >
            </hb-tooltip-component>
          </li>
          <li class="li-number-format">
            <span>
              {{ tr.shares | hbCustomFormat: '0,0' }}
            </span>
          </li>
          <li class="li-number-format">
            <span>
              {{
                tr.price
                  | hbCustomFormat
                    : (tr.price < 1 ? '$0,0[.]00[0]' : '$0,0[.]00')
              }}
            </span>
          </li>
          <li class="li-number-format">
            <span>
              {{
                tr.yieldRate
                  | hbCustomFormat
                    : (tr.yieldRate < 1 ? '0,0[.]00[0]' : '0,0[.]00')
              }}
            </span>
          </li>
          <li class="li-number-format plazo">
            <span> {{ tr.term | hbCustomFormat: '0,0' }} </span>
          </li>
          <li class="li-number-format">
            <span>
              {{
                tr.interest
                  | hbCustomFormat
                    : (tr.interest < 1 ? '$0,0[.]00[0]' : '$0,0[.]00')
              }}
            </span>
          </li>
          <li class="li-number-format">
            <span>
              {{
                tr.taxes
                  | hbCustomFormat
                    : (tr.taxes < 1 ? '$0,0[.]00[0]' : '$0,0[.]00')
              }}
            </span>
          </li>
          <li class="li-number-format">
            <span>
              {{
                tr.commision
                  | hbCustomFormat
                    : (tr.commision < 1 ? '$0,0[.]00[0]' : '$0,0[.]00')
              }}
            </span>
          </li>
          <li class="li-number-format">
            <span>
              {{
                tr.amount
                  | hbCustomFormat
                    : (tr.amount < 1 ? '$0,0[.]00[0]' : '$0,0[.]00')
              }}
            </span>
          </li>
        </ul>
      </ng-container>
      <div class="none-rows" *ngIf="transactions.length <= 0 && !showSkeleton">
        <i class="icon icon-atm-icn-ordenes"></i>
        <div *ngIf="!requestFailed">
          No se han encontrado transacciones, intenta con un intervalo nuevo.
        </div>
        <div *ngIf="requestFailed">
          Ocurrió un error al tratar de obtener las transacciones. Intenta de
          nuevo más tarde.
        </div>
      </div>
    </div>
    <div class="body-grid" *ngIf="showSkeleton">
      <ul *ngFor="let tr of emptyState" class="row-grid">
        <li class="li-text-format">
          <span class="skeleton"></span>
        </li>
        <li class="li-text-format">
          <span class="skeleton"></span>
        </li>
        <li class="li-text-format">
          <span class="skeleton"></span>
        </li>
        <li class="li-text-format">
          <span class="skeleton"></span>
        </li>
        <li class="li-text-format">
          <span class="skeleton"></span>
        </li>
        <li class="li-text-format">
          <span class="skeleton"></span>
        </li>
        <li class="li-text-format">
          <span class="skeleton"></span>
        </li>
        <li class="li-text-format">
          <span class="skeleton"></span>
        </li>
        <li class="li-text-format">
          <span class="skeleton"></span>
        </li>
        <li class="li-text-format">
          <span class="skeleton"></span>
        </li>
        <li class="li-text-format">
          <span class="skeleton"></span>
        </li>
        <li class="li-text-format">
          <span class="skeleton"></span>
        </li>
      </ul>
    </div>
  </div>
  <div class="row between-xs middle-xs see-more">
    <div class="col-xs-12 start-xs no-padding-left">
      <span>{{ page }} de {{ totalPages }} páginas.</span>

      <a (click)="getMore()" [ngClass]="{ active: totalPages <= page }"
        ><div class="lds-ring" *ngIf="showLoader">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
        Mostrar más</a
      >
    </div>
  </div>
</div>
